import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import { numberFormat } from '../../common/format';
import { normal } from '../defaultSpacing';


import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-demographic'
    },
    asyncData: mapAsyncData(asyncData),
    data: function() {
        let config = {
            fullColumn: false,
            ...normal,
            title: ''
        };
        return {
            ...config,
            url: '',
            listingDetail: null,
            isLandingpage: false
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "currencySymbol": store => store.currency.symbol
        }),
        ...mapState({
            "originDemographics": "originDemographics"
        }),
        demographics() {
            let data = this.originDemographics;
            if (!(data instanceof Object) || !Object.keys(data).length) {
                return [];
            }
            const education = data.education || {};
            let educationValue = 0;
            let educationLabel = '';
            for (let item in education) {
                if (Number(education[item]) > Number(educationValue)) {
                    educationLabel = item.replace('education', '') + ' Degree';
                    educationValue = education[item];
                }
            }
            return [
                {
                    type: '',
                    value: numberFormat(
                        Number((data.population || {}).populationCurrent),
                        true,
                        0
                    ),
                    label: this.$t('md-demographic.population')
                },
                {
                    type: 'number:-',
                    value: Math.round((data.age || {}).ageMedian),
                    label: this.$t('md-demographic.medianAge')
                },
                {
                    type: '',
                    value: Number(educationValue).toFixed(0) + '%',
                    // TODO i18n
                    label: this.$t(
                        `md-demographic.${educationLabel}`,
                        educationLabel
                    )
                },
                {
                    type: '',
                    value:
                        `${this.currencySymbol}` +
                        numberFormat(
                            Number((data.income || {}).incomeMedian),
                            true,
                            0
                        ),
                    label: this.$t('md-demographic.medianIncome')
                }
            ];
        },
        exist() {
            if (this.listingDetail.hjId && this.demographics.length > 0) {
                return true; 
            }
            if (this.isLandingpage) {
                return true; 
            }
            return false;
        },
        visible() {
            if (this.listingDetail.hjId && this.demographics.length > 0) {
                return true; 
            }
            return false;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    }
};
